module.exports = __webpack_public_path__ + "img/SMS15103-L-min.65ed6437.png";